import { render, staticRenderFns } from "./NavMenu.vue?vue&type=template&id=1ab845dd"
import script from "./NavMenu.vue?vue&type=script&lang=ts"
export * from "./NavMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports